import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  templateUrl: './printing-page.html',
  styleUrls: ['./printing-page.scss'],
})

export class PrintingPageComponent {

  letters = [
    'א',
    'ב',
    'ג',
    'ד',
    'ה',
    'ו',
    'ז',
    'ח',
    'ט',
    'י',
    'כ',
    'ל',
    'מ',
    'נ',
    'ס',
    'ע',
    'פ',
    'צ',
    'ק',
    'ר',
    'ש',
    'ת',
  ];

  constructor(
    private router:Router,
  ) {
  }


  ngOnInit() {


  }


  navTo(dest) {
    this.router.navigate([dest]);
  }


  printSection(letter) {
    console.log('printing letter', letter);
    window.open(`/admin/printing/${letter}`);
  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/printing-page/printing-page.ts